__turbopack_context__.v({
  "className": "great_vibes_7bf2676b-module__drrrlW__className",
});
